// @flow
import { createStore as _createStore, applyMiddleware, combineReducers, compose } from 'redux';
import productReducer from './modules/product';
import mediaReducer from './modules/media';
import attributesReducer from './modules/attributes';
import configurationReducer from './modules/configuration';
import quantityReducer from './modules/quantity';
import thunk from 'redux-thunk';
import { maybeServer } from '../helpers/server';
import getDefaultState from './defaultState';

const composeEnhancers: Function = process.env.NODE_ENV !== 'production' && !maybeServer.getOrElseValue(false) ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;

const middlewares = [];
middlewares.push(thunk);

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
);

const reducer = combineReducers({
  rawProduct: (state = {}) => state,
  cachedFormKey: (state = '') => state,
  product: productReducer,
  media: mediaReducer,
  attributes: attributesReducer,
  configuration: configurationReducer,
  quantity: quantityReducer,
});

const createStoreFromData = (data: Object) => {
  return _createStore(reducer, data, enhancer);
};

export const createStore = (event: ?Object = null) => getDefaultState(event).then(state => createStoreFromData(state));



// WEBPACK FOOTER //
// ./src/store/create.js